import { decodeBase64, encodeBase64 } from "./json-base-64";

export default class EventWsClient {
  constructor({ url }) {
    this.callbacks = {};
    this._open(url);
  }

  _open(url) {
    this.ws = new WebSocket(url);

    this.ws.onopen = _ => {
      console.log("Connected to websocket server at %s", url);
    };

    // ? Has potential for stack overflow
    this.ws.onclose = () => {
      console.log(
        "Disconnected from server at " +
          url +
          " attempting to reconnect in 10 seconds."
      );
      setTimeout(() => {
        this._open(url);
      }, 10000);
    };

    this.ws.onmessage = wsMessage => {
      this._onMessage(wsMessage);
    };

    this.ws.onerror = _ => {};
  }

  _onMessage(wsMessage) {
    const message = decodeBase64(wsMessage.data);

    const chain = this.callbacks[message.event.toLowerCase()];
    if (chain !== undefined) {
      chain.forEach(callback => {
        callback(message.data);
      });
    }
  }

  /**
   * Setup event callbacks for base64 encoded JSON websocket message events in the form of:
   * message: {
   *  event: "event",
   *  data: {
   *    ... // Event Data
   *  }
   * }
   * @param {string} event to define the callback for.
   * @param {Function} callback to call on the data in the event.
   */
  on(event, callback) {
    const lower = event.toLowerCase();

    if (["open", "close", "error"].includes(lower)) {
      // this.ws[`on${lower}`] = callback;
      // Defined above in _open
    } else {
      this.callbacks[lower] = this.callbacks[lower] || [];
      this.callbacks[lower].push(callback);
    }

    return this;
  }

  /**
   * Send base64 encoded JSON messages to the web socket server of the form:
   * message: {
   *  event: event,
   *  data: data
   * }
   * @param {string} event to send to the server.
   * @param {object} data to serialize in the message to the server.
   * @param {Function} errorCallback when there is an error sending.
   */
  send(event, data, errorCallback = undefined) {
    console.info(
      "Event " + event.toUpperCase() + ": \n" + JSON.stringify(data, null, 2)
    );
    this.ws.send(encodeBase64({ event: event.toUpperCase(), data }), error => {
      if (error !== undefined) {
        if (errorCallback !== undefined) {
          errorCallback(error);
        } else {
          console.log(error);
        }
      }
    });
  }
}
